import { createApi } from '../common/API';

export const uploadDataset = createApi('/upload/file', {
  method: 'POST',
  expandData: false,
  notify: true,
  noThrow: false,
});

